import React, {useEffect} from "react";
import {Link} from 'react-router-dom'
import { findObjectByKeyValue } from '../utils.js';
import { Spinner } from "../common/Spinner";
import { ErrorMessage } from "../common/ErrorMessage";
import playerIco from "../../../src/assets/player.svg"

function MobilePlayers ({
    props, 
    playersOnField,
    playerIdsOnBench,
    removePlayer, 
    touchPlayer, 
    touchedPlayer, 
    isLoading, 
    error, 
    leagueSlug
}) {
    useEffect(() => {
        if (!touchedPlayer) return undefined;

        const close = () => {
            touchPlayer(null);
        };

        window.addEventListener("click", close);
        return () => {
            window.removeEventListener("click", close);
        };
    }, [touchPlayer, touchedPlayer]);

    // Handle loading state
    if (isLoading) {
        return (
            <div className="mobile-players-container loading-container">
                <Spinner />
                <p>Loading players...</p>
            </div>
        );
    }

    // Handle error state
    if (error) {
        return (
            <div className="mobile-players-container">
                <ErrorMessage message="Error loading players" error={error} />
            </div>
        );
    }

    // Show all players, the active class will handle visual state.
    const availablePlayers = props.map(player => {
        const fieldSlot = playersOnField.find(slot => slot.player_id === player.wyId);
        const isOnBench = playerIdsOnBench.includes(player.wyId);

        let tacticalPosition;
        if (fieldSlot) {
            tacticalPosition = fieldSlot.title;
        } else if (isOnBench) {
            tacticalPosition = 'SUB';
        } else {
            // For unassigned players, show their primary position code
            tacticalPosition = player.position
                || player.role?.code3
                || player.role?.code2
                || player.role?.name
                || '-';
        }

        return {
            ...player,
            tacticalPosition,
        };
    });

    // Handle empty state for available players
    if (!availablePlayers || !availablePlayers.length) {
        return (
            <div className="mobile-players-container empty-state">
                <h3>No players available</h3>
                <p>There are no players in this team.</p>
                <Link to={`/${leagueSlug}/transfers-players`} className="settings-submit-btn">
                    GO TO TRANSFERS
                </Link>
            </div>
        );
    }

    let roleGroups = [
        {
            title: "goalkeepers",
            players: []
        },
        {
            title: "defenders",
            players: []
        },
        {
            title: "midfielders",
            players: []
        },
        {
            title: "forwards",
            players: []
        }
    ]

    // Process the API data structure using the filtered list
    availablePlayers.forEach(function (player, index) {
        
        let role = "midfielders"; // default role
        
        // Determine role based on player position or other attributes
        if (player.position) {
            const pos = player.position.toLowerCase();
            if (pos.includes('gk') || pos.includes('goalkeeper')) {
                role = "goalkeepers";
            } else if (pos.includes('cb') || pos.includes('lb') || pos.includes('rb') || pos.includes('def')) {
                role = "defenders";
            } else if (pos.includes('cm') || pos.includes('cdm') || pos.includes('cam') || pos.includes('mid')) {
                role = "midfielders";
            } else if (pos.includes('st') || pos.includes('cf') || pos.includes('lw') || pos.includes('rw') || pos.includes('fw')) {
                role = "forwards";
            }
        }
        
        // Ensure player has a role property for compatibility
        const processedPlayer = {
            ...player,
            role: player.role || role,
            id: player._id || player.id, // Ensure id is available
            name: player.name,
            number: player.number || index + 1,
            position: player.position || 'N/A',
            img: player.img || player.photo || playerIco,
            rating: player.rating || player.overall || '?'
        };
        
        if (findObjectByKeyValue(roleGroups, 'title', processedPlayer.role)) {
            findObjectByKeyValue(roleGroups, 'title', processedPlayer.role).players.push(processedPlayer);
        } else {
            // If role doesn't match any predefined groups, add to midfielders as fallback
            findObjectByKeyValue(roleGroups, 'title', 'midfielders').players.push(processedPlayer);
        }
    })

    function listPlayers({players}) {

        if (!players || players.length === 0) {
            return '';
        }

        return (
            players.map(function (player) {

                const handleTouch = (event, obj) => {
                    event.stopPropagation();
                    touchPlayer(obj);
                };

                // Logic to determine player status
                const slotOnField = playersOnField.find(slot => slot.player_id === player.wyId);
                const isOnField = !!slotOnField;
                const isOnBench = playerIdsOnBench.includes(player.wyId);
                
                // Determine CSS classes
                const activeClass = (isOnField || isOnBench) ? " active " : "";
                const touchedClass = touchedPlayer && touchedPlayer.wyId === player.wyId ? " touched " : "";

                return (
                    <div key={player.id || player.wyId}
                         className={"player-place-item " + activeClass + touchedClass}
                         onClick={(event) => {handleTouch(event, player)}}
                    >
                        <div className="icon">
                            <img src={playerIco} alt="player icon"/>
                        </div>
                        <div className="descr-block">
                            {(isOnField) && (
                                <button
                                    type="button"
                                    className="pp-clear-btn"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        removePlayer(player.wyId);
                                    }}
                                />
                            )}
                            <div className="name name_field">
                                {player.name}
                            </div>
                            <div className="position">
                                <div className="score_val score_field">
                                    {player.rating}
                                </div>
                                <div className="pos_val">
                                  {/*{isOnField ? slotOnField.title : (isOnBench ? 'SUB' : player.currentPosition)}*/}
                                    {player.tacticalPosition}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
        );
    }

    const CountAlert = () => {

        return (
            <div className="count-alert">
                <div className="tip">
                    Your squad must have a minimum of 22 players
                </div>

                <Link to={`/${leagueSlug}/transfers-players`} className="settings-submit-btn">
                    TO TRANSFERS
                </Link>

            </div>
        )
    }



    // console.log(roleGroups);

    return (
        <div className="mobile-players-container">
            <div className="mobile-players-list">
                {roleGroups.map((group, index) => (
                    listPlayers(group)
                ))}
            </div>

            { props.length < 22 ? CountAlert() : ''}

        </div>
  )
}

export {MobilePlayers}
